import {Button, ButtonProps, Typography} from "@material-ui/core";
import React, { FunctionComponent } from "react";
import { useTranslate } from "../../service/translation";

const ClearFilterButton: FunctionComponent<ButtonProps> = (props: ButtonProps) => {
    const translate = useTranslate();

    // No button variant by default, so a text button is used
    // See https://material-ui.com/components/buttons/#text-buttons
    return (
        <Button
            aria-label={translate("newshub.action.clear")}
            color="primary"
            size="small"
            {...props}
        >
            <Typography variant="h4" component="span">{translate("newshub.action.clearAll")}</Typography>
        </Button>
    );
};

export default ClearFilterButton;
